var lib_core           = require("lib-core");
var ui_templates       = require("ui-templates");
var cio_config         = require("cio-config");

var SettingsView = function(model, stateMachine, parentView, configuration) {
    this.model = model;
    this.stateMachine = stateMachine;
    this.parentView = parentView;

         // create the template
    var settingsForm = this.getTemplate();

    var descReadOnly = configuration.descriptionReadOnly;
    var propsReadOnly = configuration.propertiesReadOnly;

    var settingsName = settingsForm.addFormElement("Name");
    var settingsNameField = settingsName.addTextInput(this.model.nameShadow(), "Type your name here", configuration.nameReadOnly);
    this.addInteraction(settingsNameField, this.model.nameShadow, 'Cioui:Form:value');

    var settingsSummary = settingsForm.addFormElement("Summary");
    var settingsSummaryField = settingsSummary.addTextInput(this.model.summaryShadow(), "Type your summary here", configuration.summaryReadOnly);
    this.addInteraction(settingsSummaryField, this.model.summaryShadow, 'Cioui:Form:value');
    settingsSummary.addSubhead("A short sentence about your design, which may appear in search results.");

    var settingsDescription = settingsForm.addFormElement("Description");
    var settingsDescriptionField = settingsDescription.addTextArea(this.model.descriptionShadow(), "Type your description here", configuration.descriptionReadOnly);
    this.addInteraction(settingsDescriptionField, this.model.descriptionShadow, 'Cioui:Form:value');
    settingsDescription.addSubhead("A full description with additional information about your design. This textfield supports Markdown Syntax.");

    var settingsTags = settingsForm.addFormElement("Tags");
    var settingsTagsField = settingsTags.addTextInput(this.model.tagsShadow(), "Type your tags (comma seperated) here", configuration.propertiesReadOnly);
    this.addInteraction(settingsTagsField, this.model.tagsShadow, 'Cioui:Form:value');
    settingsTags.addSubhead("Comma seperated taglist ");

    var settingsAlias = settingsForm.addFormElement("Alias");
    var settingsAliasField = settingsAlias.addTextInput(this.model.aliasShadow(), "", configuration.propertiesReadOnly);
    this.addInteraction(settingsAliasField, this.model.aliasShadow, 'Cioui:Form:value');
    settingsAlias.addSubhead("The common or short name.");
};

// this function adds interaction to the current settings line
SettingsView.prototype.addInteraction = function(line, datamember, eventType, ignoreFocus, unit) {
    var self = this;
    // fire statemachine
    var formatter = function(val) {
        // if a number, format
        if(!isNaN(val)){
            if(unit){
                // display unit must be convertable from micrometers (default)
                val = cio_config.UnitConversions.convert("um", unit, val);
                // round result
                val = (Math.round(val * 1000) / 1000);
                return val + unit;
            }
        }
        return val;
    };

    // on data change, attempt to set
    line.$el.on(eventType, function (e, value) {
        line.$el.css("background", "");
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.CHANGE_SETTING, datamember.getTreeNode())
                .data( 'id', datamember.getName() )
                .data( 'value', value );
        return self.stateMachine.handle(cEvent);
    });

    // add 2-way coupling
    datamember.onChange(self, function () {
        if (!line.$el.is(":focus")) {
            twoWayCouple(datamember(), line, eventType);
        }
        line.$el.css("background", "");
    }, 10);

    line.$el.on('blur', null, function() {
        if(datamember() !== null && datamember() !== "") twoWayCouple(datamember(), line, eventType);
        line.$el.css("background", "");
    });

    line.$el.on("Cioui:Form:enter", function (e, value) {
        if(datamember() !== null && datamember() !== "") twoWayCouple(datamember(), line, eventType);
        line.$el.css("background", "");
    });

    if (datamember.onSetFail) {
        datamember.onSetFail(self, function () {
            line.$el.css("background", "#FF9999");
        }, 10);
    }

    line.$el.on('blur', null, function() {
        return self.stateMachine.handle(lib_core.GuiEvents.SETTINGS_BLUR);
    });

    // if text input field: add focus event as well
    if(!ignoreFocus) {
        line.$el.on('focus', null, function () {
            return self.stateMachine.handle(lib_core.GuiEvents.SETTINGS_FOCUS);
        });
    }

    function twoWayCouple(value, line, eventType) {
        value = formatter(value);
        if(line.setValue && eventType == 'Cioui:Form:value')
            line.setValue(value);
        if(line.setBoolean && eventType == 'Cioui:Form:boolean')
            line.setBoolean(value);
    }

    if(datamember() !== null && datamember() !== "") line.setValue(formatter(datamember()));
};

SettingsView.prototype.getTemplate = function(){
    if(!this._template){
        this._template = this.parentView.getTemplate().addForm();
        this.parentView.getTemplate().makeScrollable();
    }

    return this._template;
};

module.exports = SettingsView;
